import { render, staticRenderFns } from "./CheckInbox.vue?vue&type=template&id=fd8798ae&"
import script from "./CheckInbox.vue?vue&type=script&lang=js&"
export * from "./CheckInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports